class LoginDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#LoginDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderLoginIconAccessibility();
    this.setupFormSwitching();
  }

  setHeaderLoginIconAccessibility() {
    const loginTriggers = document.querySelectorAll('[data-login-drawer-trigger]');

    loginTriggers.forEach(trigger => {
      trigger.setAttribute('role', 'button');
      trigger.setAttribute('aria-haspopup', 'dialog');
      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        this.open(trigger);
      });
      trigger.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          this.open(trigger);
        }
      });
    });
  }

  setupFormSwitching() {
    // 비밀번호 찾기 링크
    const forgotPasswordLink = this.querySelector('.login-drawer__forgot-link');
    if (forgotPasswordLink) {
      forgotPasswordLink.addEventListener('click', (e) => {
        e.preventDefault();
        this.showRecoverForm();
      });
    }

    // 회원가입 폼 보기 버튼
    const showCreateAccountBtn = this.querySelector('.show-create-account');
    if (showCreateAccountBtn) {
      showCreateAccountBtn.addEventListener('click', (e) => {
        e.preventDefault();
        this.showCreateAccountForm();
      });
    }

    // 로그인 폼으로 돌아가기 버튼들
    const backToLoginBtns = this.querySelectorAll('.back-to-login');
    backToLoginBtns.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        this.showLoginForm();
      });
    });

    // 회원가입 완료 버튼 - login-drawer.liquid의 검증 로직에 맡김
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);

    // 애니메이션이 항상 트리거되도록 timeout 사용
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = document.getElementById('LoginDrawer');
        const focusElement = this.querySelector('.login-drawer__inner') || this.querySelector('.login-drawer__close');
        if (typeof trapFocus === 'function') {
          trapFocus(containerToTrapFocusOn, focusElement);
        }
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    if (typeof removeTrapFocus === 'function') {
      removeTrapFocus(this.activeElement);
    }
    document.body.classList.remove('overflow-hidden');
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  showRecoverForm() {
    this.hideAllForms();
    this.querySelector('#RecoverPasswordForm').style.display = 'block';
    this.querySelector('.login-drawer__heading').textContent = 'Reset your password';
  }

  showCreateAccountForm() {
    this.hideAllForms();
    this.querySelector('#CreateAccountForm').style.display = 'block';
    this.querySelector('.login-drawer__heading').textContent = 'Register';
  }

  showLoginForm() {
    this.hideAllForms();
    this.querySelector('#LoginForm').style.display = 'block';
    this.querySelector('.login-drawer__heading').textContent = 'ㅤ';

  }

  showRegisterComplete() {
    this.hideAllForms();
    const completeSection = this.querySelector('#RegisterCompleteForm');
    if (completeSection) {
      completeSection.style.display = 'flex';
    }
    this.querySelector('.login-drawer__heading').textContent = 'Register';
  }


  hideAllForms() {
    this.querySelector('#LoginForm').style.display = 'none';
    this.querySelector('#RecoverPasswordForm').style.display = 'none';
    this.querySelector('#CreateAccountForm').style.display = 'none';
    this.querySelector('#RegisterCompleteForm').style.display = 'none';
  }

  renderContents(parsedState) {
    // 필요시 폼 에러 상태 업데이트
    if (parsedState.errors) {
      this.renderErrors(parsedState.errors);
    }
  }

  renderErrors(errors) {
    // 에러 메시지 표시 로직
    console.log('Login errors:', errors);
  }
}

customElements.define('login-drawer', LoginDrawer);

// 전역 함수로 drawer 열기
window.openLoginDrawer = function () {
  const drawer = document.querySelector('login-drawer');
  if (drawer) {
    drawer.open();
  }
};

// 전역 함수로 drawer 닫기
window.closeLoginDrawer = function () {
  const drawer = document.querySelector('login-drawer');
  if (drawer) {
    drawer.close();
  }
};

// 폼 검증 기능
document.addEventListener('DOMContentLoaded', function () {

  // 페이지 로드 시 회원가입 완료 상태 확인
  function checkRegistrationSuccess() {
    const urlParams = new URLSearchParams(window.location.search);
    const registrationSuccess = urlParams.get('registration_success');

    if (registrationSuccess === 'true') {
      // URL에서 파라미터 제거 (뒤로가기 시 다시 실행되지 않도록)
      const newUrl = window.location.pathname + window.location.hash;
      history.replaceState({}, document.title, newUrl);

      // 약간의 지연 후 드로어 열기 (페이지 로드 완료 대기)
      setTimeout(() => {
        const loginDrawer = document.querySelector('login-drawer');
        if (loginDrawer) {
          loginDrawer.open();
          // 추가 지연 후 완료 화면 표시
          setTimeout(() => {
            loginDrawer.showRegisterComplete();
          }, 300);
        }
      }, 100);
    }
  }

  // 로컬 스토리지를 통한 상태 확인
  function checkRegistrationSuccessFromStorage() {
    const registrationSuccess = localStorage.getItem('registrationSuccess');

    if (registrationSuccess === 'true') {
      // 현재 페이지가 메인 페이지(/)인지 확인
      const isHomePage = window.location.pathname === '/' || window.location.pathname === '';

      if (isHomePage) {

        setTimeout(() => {
          const loginDrawer = document.querySelector('login-drawer');
          if (loginDrawer) {
            // 먼저 완료 폼과 타이틀 설정
            loginDrawer.showRegisterComplete();

            // 그 다음에 드로어 열기 (시각적 효과를 위해 약간의 지연)
            setTimeout(() => {
              loginDrawer.open();
            }, 100);
          } else {
          }
        }, 100);
      } else {
      }

      // 상태는 어떤 경우든 삭제
      localStorage.removeItem('registrationSuccess');
    } else {
    }
  }

  // 두 가지 방법 모두 체크
  checkRegistrationSuccess();
  checkRegistrationSuccessFromStorage();

  // 실시간 필드 검증 함수들
  function showFieldError(field, message) {
    field.classList.add('field--error');

    // 기존 에러 메시지 제거
    const existingError = field.parentNode.querySelector('.field-error-message');
    if (existingError) {
      existingError.remove();
    }

    // 새 에러 메시지 추가
    const errorDiv = document.createElement('div');
    errorDiv.className = 'field-error-message';
    errorDiv.textContent = message;
    errorDiv.style.color = '#ff0000';
    errorDiv.style.fontSize = '10px';
    errorDiv.style.marginTop = '4px';
    field.parentNode.appendChild(errorDiv);
  }

  function clearFieldError(field) {
    field.classList.remove('field--error');
    const errorMessage = field.parentNode.querySelector('.field-error-message');
    if (errorMessage) {
      errorMessage.remove();
    }
  }

  // 체크박스 에러 메시지 표시
  function showCheckboxError(checkbox) {
    checkbox.classList.add('field--error');
  }

  // 체크박스 에러 제거
  function clearCheckboxError(checkbox) {
    checkbox.classList.remove('field--error');
  }

  // 이메일 검증
  function validateEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  // 필드 검증 이벤트 리스너들
  const registerFirstName = document.getElementById('RegisterFirstName');
  const registerLastName = document.getElementById('RegisterLastName');
  const registerEmail = document.getElementById('RegisterEmail');
  const registerPassword = document.getElementById('RegisterPassword');
  const customerEmail = document.getElementById('CustomerEmail');
  const customerPassword = document.getElementById('CustomerPassword');
  const recoverEmail = document.getElementById('RecoverEmail');
  const termsCheckbox = document.getElementById('RegisterTerms');

  // 회원가입 필드 검증 - 실시간(blur)
  if (registerFirstName) {
    registerFirstName.addEventListener('blur', function () {
      if (!this.value.trim()) {
        showFieldError(this, 'First name is required');
      } else {
        clearFieldError(this);
      }
    });
  }
  if (registerLastName) {
    registerLastName.addEventListener('blur', function () {
      if (!this.value.trim()) {
        showFieldError(this, 'Last name is required');
      } else {
        clearFieldError(this);
      }
    });
  }
  if (registerEmail) {
    registerEmail.addEventListener('blur', function () {
      const email = this.value.trim();
      if (!email) {
        showFieldError(this, 'Email is required');
      } else if (!validateEmail(email)) {
        showFieldError(this, 'Please enter a valid email address');
      } else {
        clearFieldError(this);
      }
    });
  }
  if (registerPassword) {
    registerPassword.addEventListener('blur', function () {
      const password = this.value;
      if (!password) {
        showFieldError(this, 'Password is required');
        // } else if (password.length < 6) {
        //   showFieldError(this, 'Password must be at least 6 characters long');
      } else {
        clearFieldError(this);
      }
    });
  }

  // 로그인 필드 검증 - 실시간(blur)
  if (customerEmail) {
    customerEmail.addEventListener('blur', function () {
      const email = this.value.trim();
      if (!email) {
        showFieldError(this, 'Email is required');
      } else if (!validateEmail(email)) {
        showFieldError(this, 'Please enter a valid email address');
      } else {
        clearFieldError(this);
      }
    });
  }
  if (customerPassword) {
    customerPassword.addEventListener('blur', function () {
      if (!this.value) {
        showFieldError(this, 'Password is required');
      } else {
        clearFieldError(this);
      }
    });
  }

  // 비밀번호 찾기 이메일 검증 - 실시간(blur)
  if (recoverEmail) {
    recoverEmail.addEventListener('blur', function () {
      const email = this.value.trim();
      if (!email) {
        showFieldError(this, 'Email is required');
      } else if (!validateEmail(email)) {
        showFieldError(this, 'Please enter a valid email address');
      } else {
        clearFieldError(this);
      }
    });
  }

  // 회원가입 폼 제출 검증
  const createCustomerForm = document.getElementById('CreateCustomer');
  if (createCustomerForm) {
    createCustomerForm.addEventListener('submit', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();

      // 모든 필드 검증
      let hasErrors = false;

      if (registerFirstName && !registerFirstName.value.trim()) {
        showFieldError(registerFirstName, 'First name is required');
        hasErrors = true;
      }

      if (registerLastName && !registerLastName.value.trim()) {
        showFieldError(registerLastName, 'Last name is required');
        hasErrors = true;
      }

      if (registerEmail) {
        const email = registerEmail.value.trim();
        if (!email) {
          showFieldError(registerEmail, 'Email is required');
          hasErrors = true;
        } else if (!validateEmail(email)) {
          showFieldError(registerEmail, 'Please enter a valid email address');
          hasErrors = true;
        }
      }

      if (registerPassword) {
        const password = registerPassword.value;
        if (!password) {
          showFieldError(registerPassword, 'Password is required');
          hasErrors = true;
        }
      }

      // 필수 체크박스 검증
      const termsCheckboxField = document.getElementById('RegisterTerms-field');
      const termsCheckbox = document.getElementById('RegisterTerms');
      if (!termsCheckbox.checked) {
        showCheckboxError(termsCheckboxField);
        hasErrors = true;
      } else {
        clearCheckboxError(termsCheckboxField);
      }

      if (hasErrors) {
        return false;
      }


      try {
        localStorage.setItem('registrationSuccess', 'true');
      } catch (e) {
        console.error('localStorage error:', e);
      }

      // Shopify에 맡기고 일반 폼 제출
      this.submit();
    });
  }

  // 로그인 폼 검증
  const customerLoginForm = document.getElementById('CustomerLoginForm');
  if (customerLoginForm) {
    customerLoginForm.addEventListener('submit', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();

      let hasErrors = false;

      if (customerEmail) {
        const email = customerEmail.value.trim();
        if (!email) {
          showFieldError(customerEmail, 'Email is required');
          hasErrors = true;
        } else if (!validateEmail(email)) {
          showFieldError(customerEmail, 'Please enter a valid email address');
          hasErrors = true;
        }
      }

      if (customerPassword) {
        if (!customerPassword.value) {
          showFieldError(customerPassword, 'Password is required');
          hasErrors = true;
        }
      }

      if (hasErrors) {
        return false;
      }

      this.submit();
    });
  }

  // 비밀번호 찾기 폼 검증
  const recoverPasswordForm = document.getElementById('RecoverCustomerPassword');
  if (recoverPasswordForm) {
    recoverPasswordForm.addEventListener('submit', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();

      let hasErrors = false;

      if (recoverEmail) {
        const email = recoverEmail.value.trim();
        if (!email) {
          showFieldError(recoverEmail, 'Email is required');
          hasErrors = true;
        } else if (!validateEmail(email)) {
          showFieldError(recoverEmail, 'Please enter a valid email address');
          hasErrors = true;
        }
      }

      if (hasErrors) {
        return false;
      }

      this.submit();
    });
  }
});

// const sidebarLoginShadowElement = document.querySelector('.login-drawer shop-login-button');
// const sidebarLoginShadowRoot = sidebarLoginShadowElement?.shadowRoot;
// if (sidebarLoginShadowRoot) {
//   const style = document.createElement('style');
//   style.textContent = `
//     button[type="button"] { width: 100%; height: 38px; }
//     button[type="button"] span { font-size: 12px; line-height: 17px }
//   @media (min-width: 750px) {
//     button[type="button"] span { font-size: 14px; line-height: 20px; }
//    }
//   `;
//   sidebarLoginShadowRoot.append(style);
// }

(function () {
  const TARGET_TAG = 'shop-login-button';
  const existing = document.querySelector(TARGET_TAG);
  if (existing) waitForShadow(existing);

  function waitForShadow(el) {

    let tries = 0;
    const interval = setInterval(() => {
      tries++;
      if (el.shadowRoot) {
        clearInterval(interval);
        const style = document.createElement('style');
        style.textContent = `
          button[type="button"] { width: 100%; height: 38px !important; }
          button[type="button"] span { font-size: 12px; line-height: 17px !important; }
          @media (min-width: 750px) {
            button[type="button"] span { font-size: 14px; line-height: 20px !important; }
          }
        `;
        el.shadowRoot.append(style);
        console.log('[FOUND] ShadowRoot created for', el);
      } else if (tries > 50) {
        clearInterval(interval);
        console.warn('[TIMEOUT] ShadowRoot not found for', el);
      }
    }, 100);
  }
})();
